import { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { en, it, es } from '../portfolio'

const languages = { en, it, es }

// ISO 3166-1 alpha-2 codes of countries where Spanish is an official language
const spanishSpeakingCountries = [
    'AR', 'BO', 'CL', 'CO', 'CR', 'CU', 'DO', 'EC', 'ES', 'GQ', 'GT',
    'HN', 'MX', 'NI', 'PA', 'PE', 'PR', 'PY', 'SV', 'UY', 'VE',
]

const languageForCountry = (countryCode) => {
    if (countryCode === 'IT') return 'it'
    if (spanishSpeakingCountries.includes(countryCode)) return 'es'
    return 'en'
}

const LanguageContext = createContext()

const LanguageProvider = ({ children }) => {
    const [userLanguage, setUserLanguage] = useState('en')

    useEffect(() => {
        const localLanguage = localStorage.getItem('language')
        if (localLanguage && languages[localLanguage]) {
            setUserLanguage(localLanguage)
            return
        }

        // No saved preference: pick a language from the visitor's IP location
        fetch('https://ipapi.co/json/')
            .then((res) => res.json())
            .then((data) => setUserLanguage(languageForCountry(data.country_code)))
            .catch(() => setUserLanguage('en'))
    }, [])

    const setLanguage = (language) => {
        if (!languages[language]) return
        setUserLanguage(language)
        localStorage.setItem('language', language)
    }

    const portfolio = languages[userLanguage]
    const t = portfolio.translations

    return (
        <LanguageContext.Provider value={{ userLanguage, setLanguage, portfolio, t }}>
            {children}
        </LanguageContext.Provider>
    )
}

LanguageProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export { LanguageProvider, LanguageContext }
